import { c as _c } from "react/compiler-runtime";
// Global CSS files can only be imported into this file. See https://nextjs.org/docs/messages/css-global.
import '@netpurpose/np-ui/src/themes/fonts.css';
import '@netpurpose/np-ui/src/themes/light/reset-styles.css';

// import { hijackEffects } from 'stop-runaway-react-effects'

import { initialiseAuthProvider } from '@netpurpose/api';
import { isPreviewEnv } from '@netpurpose/utils';
import { Analytics as VercelAnalytics } from '@vercel/analytics/next';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import ContextProvider from '#context/ContextProvider';

// Uncomment to monitor infinite loops in useEffect hooks.
// if (process.env.NODE_ENV === 'development') {
//   hijackEffects()
// }

initialiseAuthProvider();
const App = t0 => {
  const $ = _c(7);
  const {
    Component,
    pageProps
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Head><meta name="viewport" content="width=device-width, initial-scale=1.0" /></Head>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== Component || $[2] !== pageProps) {
    t2 = <ContextProvider><Component {...pageProps} /></ContextProvider>;
    $[1] = Component;
    $[2] = pageProps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <VercelAnalytics beforeSend={_temp} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <>{t1}{t2}{t3}</>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default App;
function _temp(event) {
  if (isPreviewEnv()) {
    return null;
  }
  return event;
}